import config from '@/config';
import useCache from '@/hooks/useCache';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './components/VirtualList';

import './index.css';

export default function Ratings({ profileData, internal }) {
  const { loading, fetchData, loadMoreData } = useCache(
    `${profileData._id}_ratings`,
    `${config.apis.api.url}/rating/user/${profileData._id}`,
    {
      injectToken: true,
      invalidateWhen: ["NEW_RATING", `${profileData._id}_REFRESH`],
    }
  );

  if (loading) {
    return (
      <div className="profile-community-ratings-loader-container">
        <ProfileContentLoader />
      </div>
    );
  } else {
    return (
      <>
        {fetchData.data.length === 0 ? (
          <Text className="profile-community-ratings__empty-text" paragraph small>
            {internal
              ? "Your ratings will build up this view."
              : "No ratings available."}
          </Text>
        ) : (
          <VirtualList items={fetchData} onLoadMore={loadMoreData} />
        )}
      </>
    );
  }
}
